import { render, staticRenderFns } from "./BrandTypographyCategory.vue?vue&type=template&id=c67e59ae&"
import script from "./BrandTypographyCategory.vue?vue&type=script&lang=ts&"
export * from "./BrandTypographyCategory.vue?vue&type=script&lang=ts&"
import style0 from "./BrandTypographyCategory.vue?vue&type=style&index=0&id=c67e59ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports